import { Injectable } from '@angular/core';
import { InvoiceDto } from '../dtos/invoice.dto';
import { Invoice } from '../../domain/models/invoice.model';

@Injectable()
export class InvoiceMapper {
  public toInvoice(dto: InvoiceDto): Invoice {
    return {
      id: dto.ExternalId,
      number: dto.InvoiceNumber ?? null,
      patientNames: dto.PatientNames,
      date: dto.InvoiceDate ?? null,
      total: dto.TotalWithVat ?? null,
      isPending: dto.IsPending,
    };
  }
}
